import { REACT_APP_REFRESH_TOKEN } from "../../config/constantes";
import { validarFormatoFecha } from "../Fechas/validarFormatoFecha";

const prometeValidarLogin = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config)
      .then((data) => data.json())
      .then((json) => {
        if (json.StatusCode === 200 && json.Code === "1") {
          resolver(json);
        } else {
          rechazar(new Error(json.Message));
        }
      })
      .catch((error) => {
        rechazar(new Error(`Error en la solicitud: ` + error.message));
      });
  });
};


export let crearTokenGlo = async (setAuth, navigate) => {

  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));


  const variablesEnvio = {
    access_token: tokenGlos.access_token,
    key_encrypt: tokenGlos.key_encrypt
  }

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(variablesEnvio),
  };

  try {
    // API_RENOVACION_TOKEN_GLOBAL
    let token = await prometeValidarLogin(REACT_APP_REFRESH_TOKEN, config);


    let { Data } = token;

    const { access_token, expires_in, key_encrypt } = Data

    let segundosAminutos = expires_in / 60;
    let currentDate = new Date();
    let fechaFuturaExpira = new Date(
      currentDate.getTime() + segundosAminutos * 60000
    );

    localStorage.setItem(
      "tokenGlo",
      JSON.stringify({
        ...tokenGlos,
        access_token: access_token,
        expires_in: fechaFuturaExpira,
        key_encrypt: key_encrypt
      })
    );

    return {
      access_token: access_token,
      expires_in: fechaFuturaExpira,
      key_encrypt: key_encrypt
    }
  } catch (error) {
    setAuth({});
    navigate("auth");
    localStorage.removeItem("tokenGlo");
    localStorage.removeItem("token");
  }


};




let validarCrearToken = async (setAuth, navigate) => {


  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  let token = localStorage.getItem("token");
  try {

    if (validarFormatoFecha(tokenGlos?.expires_in) && token && tokenGlos?.access_token && tokenGlos?.key_encrypt) {
      // 300000 MILISEGUNDOS  = A 5 MINUTOS
      if ((new Date(tokenGlos.expires_in) - new Date()) <= 300000) {

        let crearToken = await crearTokenGlo(setAuth, navigate);
        let { access_token, expires_in } = crearToken
        return { access_token, expires_in }
      } else {
        return { access_token: tokenGlos.access_token, expires_in: tokenGlos.expires_in }
      }

    } else {
      setAuth({})
      navigate("/auth");
      localStorage.removeItem("tokenGlo");
      localStorage.removeItem("token");
    }
  } catch (error) {

  }

};

export { validarCrearToken };
